module.exports = __webpack_public_path__ + "img/wq.9a42add5.png";